﻿export class User {
  email: string;
  password: string;
  legalName: string;
}
